import React from 'react';
import {Ink, Motion, Radii} from "../../../colors";

interface PopupProps {
    isOpen: boolean;
    close: () => void;
    title?: string;
    children: React.ReactNode;
    position?: 'center' | 'top';
    closeText?: string;
}

const Popup: React.FC<PopupProps> = ({
                                         children,
                                         isOpen,
                                         close,
                                         title,
                                         position = 'center',
                                         closeText = 'Close',
                                     }) => {
    if (!isOpen) return null;

    const alignmentClass =
        position === 'top' ? 'items-start pt-[3vh]' : 'items-center';

    return (
        <div
            className={`fixed inset-0 z-50 flex justify-center ${alignmentClass} bg-black/40 backdrop-blur-sm`}
        >
            <div
                className={`relative ${Radii.xl} mx-auto`}
                style={{maxHeight: 'calc(100vh - 20vh)'}}
            >
                {(title || closeText) && (
                    <div className={`flex items-center justify-between mb-3 px-1`}>
                        <span className={`text-sm font-semibold ${Ink.onDark}`}>{title}</span>
                        <button
                            onClick={close}
                            className={`text-sm font-medium text-zinc-200 hover:text-white ${Motion.fast}`}
                        >
                            {closeText}
                        </button>
                    </div>
                )}
                {children}
            </div>
        </div>
    );
};

export default Popup;

